import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-fee',
  templateUrl: './fee.component.html',
  styleUrls: ['./fee.component.css']
})
export class FeeComponent implements OnInit {

  @Input("fees") fees: any[];
  @Input("collapsed") collapsed: boolean;
  @Input("withHeader") withHeader: boolean;
  @Output("onDelete") delete = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  deleteFee(fee: any) {
    this.delete.emit(fee);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/fee/fee.component.ts